export const ORDER_MATERIAL_TOGGLE_IS_BAND_CONNECTED = 'ORDER_MATERIAL/TOGGLE_IS_BAND_CONNECTED'

export const orderMaterialToggleIsBandConnected = ({material}) => {
    return {
        type: ORDER_MATERIAL_TOGGLE_IS_BAND_CONNECTED,
        payload: material
    }
}